import { useState, useEffect } from "react"

const sections = [
    { id: "home", icon: "/_icon.png", label: "Home" },
    { id: "about", icon: "/about_icon.png", label: "About me" },
    { id: "skills", icon: "/skills_icon.png", label: "My Skills" },
    { id: "experience", icon: "/experience_icon.png", label: "My Experience" },
    { id: "contact", icon: "/contact_icon.png", label: "Contact Me" },
]

export default function SideNav() {
    const [active, setActive] = useState("home")

    useEffect(() => {
        // Active = the last section whose top edge has passed the vertical middle
        // of the viewport, i.e. the one currently occupying the center. This is
        // deterministic, so it never gets "stuck" on the first section.
        function onScroll() {
            const middle = window.innerHeight / 2
            let current = sections[0].id
            for (const { id } of sections) {
                const el = document.getElementById(id)
                if (el && el.getBoundingClientRect().top <= middle) current = id
            }
            setActive(current)
        }

        onScroll()
        window.addEventListener("scroll", onScroll, { passive: true })
        window.addEventListener("resize", onScroll)
        return () => {
            window.removeEventListener("scroll", onScroll)
            window.removeEventListener("resize", onScroll)
        }
    }, [])

    return (
        <nav className="fixed left-0 top-0 z-50 flex h-screen w-20 flex-col items-center justify-center gap-10">
            {sections.map(({ id, icon, label }) => (
                <a
                    key={id}
                    href={`#${id}`}
                    title={label}
                    className={`w-8 text-center transition-all duration-300 ease-in ${
                        active === id
                            ? "opacity-100 scale-[1.9]"
                            : "opacity-40 scale-[1.5] hover:opacity-80 hover:scale-[1.8]"
                    }`}
                >
                    <img
                        src={icon}
                        alt={label}
                        className={`nav-icon ${active === id ? "nav-icon--active" : ""}`}
                    />
                </a>
            ))}
        </nav>
    )
}
